// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { InsuranceClaimStatusResponse } from './insurance-claim-status-response';

// @ts-ignore
import { PatientNameResponse } from './patient-name-response';

/** See com.rev360.pms.api.controller.accounting.claims.EClaimsInsuranceClaimResponse */
/* istanbul ignore next */
@GandalfModel
export class EClaimsInsuranceClaimResponse extends GandalfModelBase {

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	claimDate!: Date;

	@GandalfArray(InsuranceClaimStatusResponse)
	claimStatusMessages!: InsuranceClaimStatusResponse[];

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	claimSubmitDate!: Date | null;

	@GandalfProperty({ designType: Number })
	encounterId!: number | null;

	@GandalfProperty({ designType: Number })
	id!: number;

	@GandalfProperty({ designType: String })
	insuranceName!: string;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	invoiceDate!: Date | null;

	@GandalfProperty({ designType: Number })
	invoiceId!: number | null;

	@GandalfProperty({ designType: Number })
	patientId!: number;

	@GandalfProperty({ designType: PatientNameResponse })
	patientName!: PatientNameResponse;

	@GandalfProperty({ designType: String })
	priority!: string | null;

	@GandalfConstantDecorator(constants.ClaimProcessingStatus)
	@GandalfProperty({ designType: constants.ClaimProcessingStatus })
	processingStatus!: constants.ClaimProcessingStatus;

	@GandalfProperty({ designType: String })
	secondaryPayerPracticeInsuranceCompanyName!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	serviceDate!: Date | null;

	@GandalfConstantDecorator(constants.InsuranceClaimStatus)
	@GandalfProperty({ designType: constants.InsuranceClaimStatus })
	status!: constants.InsuranceClaimStatus;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	statusDate!: Date | null;

}
